import { Flex } from "@radix-ui/themes";
import { useAppSelector } from "../../hooks/hooks";
import { motion } from "framer-motion";
import { BASE_URL, UPLOAD_IMAGES } from "../../utils/constants";
import { useIES } from "../../hooks/useIES";
export const FullPageLoader = () => {
  const { IES, isLoading } = useIES();
  const isAvailable = useAppSelector(
    (state) => state.loaderController.isAvailable
  );

  if (!isAvailable) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        zIndex: 9999,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        backdropFilter: "blur(5px)",
        color: "#000",
      }}
    >
     
      <Flex direction="column" align="center" justify="center" gap="3">
        {/* Animação do logo */}
        <motion.img
          src={`${IES.LOGO}`}
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "20px",
            boxShadow: "0 0 25px rgba(223, 98, 26, 0.6)",
          }}
          animate={{
            scale: [1, 1.15, 1],
            rotate: [0, 10, -10, 0],
            boxShadow: [
              "0 0 20px var(--accent-5)",
              "0 0 40px var(--accent-10)",
              "0 0 20px var(--accent-11)",
            ],
            opacity: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Texto animado */}
        <motion.p
          style={{ fontWeight: 600, fontSize: "1.1rem", color: "#333" }}
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          A carregar...
        </motion.p>
      </Flex>
    </div>
  );
};